import { IThemeComponentVariation } from '@belong/types';
import { getButtonVariants } from './button';

export const componentVariations = (): IThemeComponentVariation => ({
  accordion: {
    iconButtonColor: 'BELONG_BLUE'
  },
  button: getButtonVariants(),
  card: {
    backgroundColor: 'GREY_700',
    borderColor: 'GREY_600'
  },
  icon: {
    spotBackgroundColor: 'GREY_700'
  },
  inclusion: {
    iconColor: 'BELONG_BLUE'
  }
});
